import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const useDuplicateTrialMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ sourceTrialId, trialData }) => {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${__API_URL__}/api/photos/duplicate_trial/${sourceTrialId}/`,
        trialData,
        { headers: { Authorization: `Token ${token}` } }
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["trials_list"] });
    },
  });
};

export default useDuplicateTrialMutation;
